import type { Card } from '../types/card'

/**
 * 阶段对应的复习间隔天数
 * stage 0 → 立即, 1 → 1天, 2 → 3天, 3 → 7天, 4 → 15天, 5 → 30天
 */
const INTERVAL_DAYS: Record<number, number> = {
  0: 0,
  1: 1,
  2: 3,
  3: 7,
  4: 15,
  5: 30,
}

function addHours(date: Date, hours: number): string {
  return new Date(date.getTime() + hours * 3600_000).toISOString()
}

function addDays(date: Date, days: number): string {
  return new Date(date.getTime() + days * 86_400_000).toISOString()
}

export function reviewCard(card: Card, rating: 'forgot' | 'hard' | 'easy'): Card {
  const now = new Date()

  switch (rating) {
    case 'forgot':
      return {
        ...card,
        stage: 0,
        nextReviewDate: now.toISOString(),
      }

    case 'hard':
      return {
        ...card,
        nextReviewDate: addHours(now, 1),
      }

    case 'easy': {
      const nextStage = Math.min(card.stage + 1, 5)
      return {
        ...card,
        stage: nextStage,
        nextReviewDate: addDays(now, INTERVAL_DAYS[nextStage]),
      }
    }
  }
}
